import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_gosto-marseille-1/artifacts/5h91p5vw_ChatGPT%20Image%2013%20f%C3%A9vr.%202026%2C%2021_11_06%20-%20Copie.png";

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex-shrink-0">
              <img src={LOGO_WHITE} alt="GOSTO TAXI Marseille" className="h-14 w-auto" />
            </Link>
            <Link to="/">
              <Button variant="outline" className="border-[#1a365d] text-[#1a365d]">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Retour
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="py-16 md:py-24" data-testid="politique-confidentialite-page">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold text-[#1a365d] mb-8">Politique de Confidentialité</h1>

          <div className="prose prose-slate max-w-none space-y-8">
            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Introduction</h2>
              <p className="text-slate-600 mt-4">
                GOSTO TAXI s'engage à protéger la vie privée des utilisateurs de son site web www.gostotaxi.com. Cette politique de confidentialité décrit les types d'informations que nous collectons, comment nous les utilisons et les mesures que nous prenons pour les protéger, conformément au Règlement Général sur la Protection des Données (RGPD).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Responsable du traitement</h2>
              <p className="text-slate-600 mt-4">
                <strong>GOSTO TAXI</strong><br />
                Oualid AHAMRI<br />
                4 Traverse Aubanel, 13140 Miramas<br />
                Email : ahamri.oualid@gmail.com<br />
                Téléphone : 07 72 06 72 23
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Données collectées</h2>
              <p className="text-slate-600 mt-4">
                Nous collectons les données suivantes via nos formulaires de réservation et de contact :
              </p>
              <ul className="list-disc pl-6 text-slate-600 mt-2 space-y-1">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Adresses de départ et d'arrivée (pour les réservations)</li>
                <li>Date et heure souhaitées (pour les réservations)</li>
                <li>Type de transport souhaité (privé ou médical)</li>
                <li>Messages et informations complémentaires</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Finalité du traitement</h2>
              <p className="text-slate-600 mt-4">
                Les données collectées sont utilisées exclusivement pour :
              </p>
              <ul className="list-disc pl-6 text-slate-600 mt-2 space-y-1">
                <li>Traiter vos demandes de réservation de taxi</li>
                <li>Répondre à vos demandes de contact et d'information</li>
                <li>Vous recontacter pour confirmer ou préciser votre demande</li>
                <li>Améliorer nos services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Base légale</h2>
              <p className="text-slate-600 mt-4">
                Le traitement de vos données repose sur :
              </p>
              <ul className="list-disc pl-6 text-slate-600 mt-2 space-y-1">
                <li>Votre consentement lors de la soumission des formulaires</li>
                <li>L'exécution d'un contrat de transport</li>
                <li>Notre intérêt légitime à répondre à vos demandes</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Durée de conservation</h2>
              <p className="text-slate-600 mt-4">
                Vos données personnelles sont conservées pendant une durée de 3 ans à compter de votre dernière interaction avec nous, sauf obligation légale de conservation plus longue (notamment pour les justificatifs de transport médical).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Destinataires des données</h2>
              <p className="text-slate-600 mt-4">
                Vos données sont destinées uniquement au responsable de GOSTO TAXI et ne sont en aucun cas transmises à des tiers, sauf :
              </p>
              <ul className="list-disc pl-6 text-slate-600 mt-2 space-y-1">
                <li>Aux organismes de sécurité sociale dans le cadre du transport médical conventionné</li>
                <li>Aux autorités compétentes en cas d'obligation légale</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Sécurité des données</h2>
              <p className="text-slate-600 mt-4">
                Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Vos droits</h2>
              <p className="text-slate-600 mt-4">
                Conformément au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-6 text-slate-600 mt-2 space-y-1">
                <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
                <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
                <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
                <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
                <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
              </ul>
              <p className="text-slate-600 mt-4">
                Pour exercer ces droits, contactez-nous à : ahamri.oualid@gmail.com
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Réclamation</h2>
              <p className="text-slate-600 mt-4">
                Si vous estimez que le traitement de vos données ne respecte pas la réglementation, vous pouvez introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : www.cnil.fr
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Cookies</h2>
              <p className="text-slate-600 mt-4">
                Ce site n'utilise pas de cookies de tracking ou publicitaires. Seuls des cookies techniques essentiels au bon fonctionnement du site peuvent être utilisés.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Modification de la politique</h2>
              <p className="text-slate-600 mt-4">
                Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page avec la date de mise à jour.
              </p>
              <p className="text-slate-600 mt-4">
                <strong>Dernière mise à jour :</strong> Février 2025
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0f172a] py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-400 text-sm">
          © 2025 GOSTO TAXI. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
}
